import { useEffect } from 'react'
import { Navigate } from 'react-router-dom'

import CompanyList from '../../components/dashboard/company-list'
import DashboardHeader from '../../components/dashboard/header'
import HistoricalIndexChart from '../../components/dashboard/historical-index-chart'
import IndexChart from '../../components/dashboard/index'
import OutOfStock from '../../components/dashboard/out-of-stock'
import PriceChanges from '../../components/dashboard/price-changes'
import PricePosition from '../../components/dashboard/price-position'
import Wrapper from '../../layouts/wrapper'
import { useDashboardQuery, useMeQuery } from '../../store/api'
import { useProductsQuery } from '../../store/api/product'
import type { PaginatedQueryParams } from '../../store/types'
import { IntercomEvent } from '../../utils/helpers/getIntercomMsg'
import useIntercomInternal from '../../utils/hooks/use-intercom-internal'
import useReloadLocationOnClick from '../../utils/hooks/use-reload-location-on-click'

const initialFilters: PaginatedQueryParams = {
  page: 1,
  limit: 10,
  orderBy: 'name',

  orderDirection: 'asc',
}

export default function DashboardIndex(): JSX.Element {
  const { data: products, refetch: refetchProducts } =
    useProductsQuery(initialFilters)
  const { data, refetch: refetchDashboard } = useDashboardQuery()
  const { trackEventInternal } = useIntercomInternal()
  const { data: userData } = useMeQuery()

  useEffect(() => {
    trackEventInternal(IntercomEvent['dashboard-visited'])
  }, [])

  useReloadLocationOnClick(() => {
    refetchDashboard()
    refetchProducts()
  })

  if (userData.is_onboarding_completed === 0) {
    return <Navigate replace to={'/onboarding'} />
  } else if (userData && !userData.has_tracker) {
    return <Navigate replace to={'/products'} />
  }

  return (
    <>
      <Wrapper>
        <DashboardHeader
          topbar={data?.topbar}
          trackingSummary={data?.tracking_summary}
        />
        <div className="grid sm:grid-cols-11 sm:gap-6 gap-4 pt-8 mb-16">
          <PriceChanges changes={data?.price_changes} view="Dashboard" />
          <OutOfStock
            outOfStock={data?.out_of_stock}
            company={userData}
            view="Dashboard"
          />
          {userData && userData.package_type !== 'S' && <IndexChart />}
        </div>
        <PricePosition position={data?.position} view="Dashboard" />
        <div className="flex flex-col mb-16">
          <CompanyList />
          {userData && userData.package_type !== 'S' && (
            <HistoricalIndexChart />
          )}
        </div>
      </Wrapper>
    </>
  )
}
